import api from './axios';

// SAP OData API services for Production Lots

/**
 * Get production lot details by SAP Production Task ID
 * Fetches from SAP OData: ProductionLotConfirmationGroupCollection with expanded activities
 * @param {string} taskId - SAP Production Task ID (e.g., "14273")
 */
export const getProductionLotByTaskId = async (taskId) => {
  const response = await api.get(`/api/sap-odata/production-lots/${encodeURIComponent(taskId)}`);
  return response.data;
};

/**
 * Get all production lots from SAP OData
 * @param {Object} params - Optional filters
 * @param {string} params.fromDate - ISO date string for start filter
 * @param {string} params.toDate - ISO date string for end filter
 */
export const getAllProductionLots = async (params = {}) => {
  const response = await api.get('/api/sap-odata/production-lots', { params });
  return response.data;
};

/**
 * Helper to format duration string for display
 * SAP returns durations like "PT2H30M" (ISO 8601)
 */
export const formatDuration = (duration) => {
  if (!duration) return '-';
  
  // Parse ISO 8601 duration (e.g., PT2H30M, PT45M, PT1H)
  const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
  if (!match) return duration;
  
  const hours = match[1] ? parseInt(match[1]) : 0;
  const minutes = match[2] ? parseInt(match[2]) : 0;
  
  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  }
  return duration;
};

/**
 * Calculate total planned hours from activities
 */
export const calculateTotalPlannedHours = (activities) => {
  if (!activities || !activities.length) return 0;
  
  return activities.reduce((total, activity) => {
    const duration = activity.plannedDuration || '';
    const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
    if (!match) return total;
    
    const hours = match[1] ? parseInt(match[1]) : 0;
    const minutes = match[2] ? parseInt(match[2]) : 0;
    
    return total + hours + (minutes / 60);
  }, 0);
};
